import { render } from "./alertBell.vue?vue&type=template&id=eb253ba8&scoped=true"
import script from "./alertBell.vue?vue&type=script&lang=js"
export * from "./alertBell.vue?vue&type=script&lang=js"

import "./alertBell.vue?vue&type=style&index=0&id=eb253ba8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb253ba8"]])

export default __exports__